import { GraphqlHighlightProductProvider } from './infrastructure';
import { HighlightProductProvider } from './domain';

export * from './domain';
export * from './infrastructure';

const highlightProductProvider: HighlightProductProvider =
  new GraphqlHighlightProductProvider();

export { highlightProductProvider };
